import { Container, Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { GetStaticProps, NextPage } from 'next'
import { signIn } from 'next-auth/react'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import commonTranslations from '../constants/commonTranslations'
import ChangePasswordFormContainer from '../features/profile/containers/CreatePasswordFormContainer'
import useAuthClaims from '../hooks/useAuthClaims'
import COLORS from '../styles/colors'

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || 'en', [
        ...commonTranslations,
        'CreatePasswordForm',
        'WelcomePage',
      ])),
    },
  }
}

const WelcomePage: NextPage = () => {
  const { loading: userLoading, isAuthenticated } = useAuthClaims()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { t } = useTranslation('WelcomePage')
  const router = useRouter()
  const token =
    (typeof router.query.token === 'string' && router.query.token) || undefined

  useEffect(() => {
    const fetchSignIn = async () => {
      if (!userLoading) {
        if (isAuthenticated) {
          setIsLoading(true)
          router.push('/')
        } else if (!token) {
          setIsLoading(true)
          await signIn('auth0')
        }
      }
    }

    fetchSignIn()
  }, [userLoading, isAuthenticated, router, token])

  const loading = userLoading || isLoading

  return (
    <>
      <Head>
        <title>{t('pageTitle')}</title>
      </Head>
      <Container maxWidth="sm">
        {!loading && (
          <Stack
            alignItems="center"
            direction="column"
            gap="40px"
            sx={{ backgroundColor: COLORS.beige }}
            width="100%"
          >
            <Stack alignItems="center" gap="10px" width="100%">
              <Typography
                component="h1"
                sx={{ mt: '40px' }}
                variant="garage_h3"
                color={COLORS.greyDark}
              >
                {t('title')}
              </Typography>
              <Box>
                <Typography textAlign="center">{t('subTitleText1')}</Typography>
                <Typography textAlign="center">{t('subTitleText2')}</Typography>
              </Box>
            </Stack>
            {token && <ChangePasswordFormContainer token={token} />}
          </Stack>
        )}
      </Container>
    </>
  )
}

export default WelcomePage
